<template>
  <pt-save-sign class="pt-save-sign__withData"></pt-save-sign>
</template>

<script>
import PtSaveSign from './index'
export default {
  name: 'pt-save-sign__withData',
  components: {
    'pt-save-sign': PtSaveSign
  }
}
</script>
